// import { ContactForm } from "../components/Form/ContactForm";
import { FadeInOnScroll } from "../components/FadeInOnScoll/FadeInOnScroll";
import { useTranslation } from "react-i18next";

export const Contact = () => {
  const { t } = useTranslation();
  // const siteKeyV3 = import.meta.env.VITE_RECAPTCHA_SITE_KEY_DEV as string;

  return (
    <div className="bg-gray text-dark pt-40 pb-15 px-4 lg:px-20 -mt-40 lg:-mt-20 relative z-0">
      <FadeInOnScroll>
        <h3 id="contact" className="title-page">
          {t("contact")}
        </h3>
      </FadeInOnScroll>
      <FadeInOnScroll delay={200}>
        <div className="text-center">
          <p>Duo Durand-LeLudec/Daniel</p>
          <p>{t("email-ddd")}</p>
          <br />

          <p>{t("text-contact-brendan")}</p>
          <p>{t("text-contact-jo")}</p>
          <br />

          <p>Site internet : Jonathan Daniel</p>
          <p>{t("email-jo")}</p>
        </div>
        {/* <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10">
          <ContactForm siteKeyV3={siteKeyV3} />
        </div> */}
      </FadeInOnScroll>
    </div>
  );
};
